import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'urlCurta'
})
export class UrlEncurtadaPipe implements PipeTransform {
    transform(value: string, limit: number = 100): string {

        if (!value) {
            return '---';
        }

        if (value.length > limit) {
            return value.substring(0, limit) + '...';
        } else {
            return value;
        }
    }
}
